"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/use-theme";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-[var(--color-border)] text-[var(--color-text-secondary)] transition-colors hover:text-[var(--color-primary)] hover:border-[var(--color-primary)]"
    >
      {/* Sun (shown in dark mode → offers switch to light) */}
      <span
        aria-hidden
        className="absolute inline-flex transition-[opacity,transform] duration-300 ease-out"
        style={{
          opacity: isDark ? 1 : 0,
          transform: isDark ? "rotate(0deg) scale(1)" : "rotate(-90deg) scale(0.4)",
        }}
      >
        <Sun size={16} />
      </span>
      {/* Moon (shown in light mode → offers switch to dark) */}
      <span
        aria-hidden
        className="absolute inline-flex transition-[opacity,transform] duration-300 ease-out"
        style={{
          opacity: isDark ? 0 : 1,
          transform: isDark ? "rotate(90deg) scale(0.4)" : "rotate(0deg) scale(1)",
        }}
      >
        <Moon size={16} />
      </span>
    </button>
  );
}
